import { t } from 'translations'

export type FilterCategory =
    | 'products'
    | 'website_traffic_acquisition_channel'
    | 'device_type'
    | 'payment_method'
    | 'checkout_acquisition_channel_category'
    | 'location_id'
    | 'language'
    | 'confirmation_flow'
    | 'capacity_type'
    | 'time_slots'
    | 'availability_pool_uuid'
    | 'product_types'
    | 'capacity_pools'
    | 'channels'
    | 'categories'
    | 'email_status'
    | 'apf_status'
    | 'order_status'
    | 'payment_status'
    | 'ticket_status'
    | 'redeem_status'
    | 'print_status'
    | 'tool_type'
    | 'tool_status'
    | 'audience'
    | 'user_role'
    | 'partner'
    | 'industry'
    | 'tap_notifications_campaign_name'
    | 'tap_platform'
    | 'tap_notifications_category'
    | 'tap_notifications_target_type'
    | 'tap_notifications_schedule_type'
    | 'marketing_permission'
    | 'purchases'
    | 'preferred_device_type'
    | 'email_identified'
    | 'product_lists'
    | 'product_lists_with_screens'
    | 'status'
    | 'reservation_status'
    | 'apf_fields'
    | 'membership_status'
    
// A function so the labels are translated when they are shown, not when this module loads.
export const getCategoryNameMap = () => ({
    products: t('uiComponents.filter.categories.product'),
    website_traffic_acquisition_channel: t('uiComponents.filter.categories.trafficAcquisitionChannel'),
    checkout_acquisition_channel_category: t('uiComponents.filter.categories.checkoutAcquisitionChannel'),
    device_type: t('uiComponents.filter.categories.deviceType'),
    payment_method: t('uiComponents.filter.categories.paymentMethod'),
    location_id: t('uiComponents.filter.categories.location'),
    language: t('uiComponents.filter.categories.language'),
    confirmation_flow: t('uiComponents.filter.categories.checkoutFlow'),
    product_types: t('uiComponents.filter.categories.productType'),
    capacity_pools: t('uiComponents.filter.categories.capacity'),
    channels: t('uiComponents.filter.categories.salesChannel'),
    email_status: t('uiComponents.filter.categories.emailStatus'),
    apf_status: t('uiComponents.filter.categories.apfStatus'),
    order_status: t('uiComponents.filter.categories.orderStatus'),
    payment_status: t('uiComponents.filter.categories.paymentStatus'),
    ticket_status: t('uiComponents.filter.categories.ticketStatus'),
    redeem_status: t('uiComponents.filter.categories.redeemStatus'),
    print_status: t('uiComponents.filter.categories.printStatus'),
    tool_type: t('uiComponents.filter.categories.toolType'),
    tool_status: t('uiComponents.filter.categories.status'),
    audience: t('uiComponents.filter.categories.audience'),
    user_role: t('uiComponents.filter.categories.userRole'),
    partner: t('uiComponents.filter.categories.partner'),
    industry: t('uiComponents.filter.categories.industry'),
    preferred_device_type: t('uiComponents.filter.categories.preferedDeviceType'),
    email_identified: t('uiComponents.filter.categories.emailIdentified'),
    marketing_permission: t('uiComponents.filter.categories.marketingPermission'),
    purchases: t('uiComponents.filter.categories.purchases'),
    tap_notifications_campaign_name: t('uiComponents.filter.categories.name'),
    tap_platform: t('uiComponents.filter.categories.platform'),
    tap_notifications_category: t('uiComponents.filter.categories.campaigns'),
    tap_notifications_target_type: t('uiComponents.filter.categories.audience'),
    tap_notifications_schedule_type: t('uiComponents.filter.categories.campaignType'),
    platform: t('uiComponents.filter.categories.platform'),
    product_lists: t('uiComponents.filter.categories.productList'),
    product_lists_with_screens: t('uiComponents.filter.categories.screenSelection'),
    status: t('uiComponents.filter.categories.orderStatus'),
    reservation_status: t('uiComponents.filter.categories.status'),
    apf_fields: t('uiComponents.filter.categories.details'),
    membership_status: t('uiComponents.filter.categories.status'),
})

export const multiLevelCategories: FilterCategory[] = ['channels', 'product_lists', 'product_lists_with_screens']

export interface AvailableFilters {
    [key: string]: FilterCategory[]
}

export interface Filters {
    attribute: string
    values: string[]
}

export interface RawFilterOption {
    slug: string
    display_name: string
    children: RawFilterOption[]
}

export interface Article {
    id: string
    name: string
    numericId: string
    apfEnabled?: boolean
}

export interface ProductsMetaData {
    uuid: string
    name: string
    articles: Article[]
    children: ProductsMetaData[]
}

export interface RawMetaData {
    products: ProductsMetaData[]
    website_traffic_acquisition_channel: RawFilterOption[]
    checkout_acquisition_channel_category: RawFilterOption[]
    device_type: RawFilterOption[]
    payment_method: RawFilterOption[]
    location_id: RawFilterOption[]
    language: RawFilterOption[]
    tool_type: RawFilterOption[]
    tool_status: RawFilterOption[]
    audience: RawFilterOption[]
    channels: RawFilterOption[]
    apf_fields: RawFilterOption[]
}

export interface MetaData {
    category: FilterCategory
    options: FilterOption[]
}

export interface FilterQueryItems {
    slug: string
    category: FilterCategory
}

export interface SingleLevelFilterOption {
    name: string
    slug: string
}

export interface FilterOption extends SingleLevelFilterOption {
    category: FilterCategory
    parents: string[]
    children: FilterOption[]
    leafNode: boolean
    priority?: number
    divider?: boolean
    heading?: string
}
